<template>

  <!-- Icons Accordion Element -->
  <page-block
    :text-color="value.textColor"
    :text-align="value.textAlign"
    :width-class="value.widthClass"
    class="icons-accordion-element"
    :class="{'has-image': value.file}"
    :bg-color="value.bgColor || '#efefef'"
    :overlay-class="value.paddingClass || 'ibs-pa'">

    <div
      class="icons-accordion-element__header">

      <div
        v-if="value.file">

        <q-img
          contain
          width="80px"
          height="80px"
          class="no-shrink"
          :src="getFileUrl(value.file, 200)"
          placeholder-src="/images/placeholder/image.png"/>

      </div>

      <div
        class="row items-center full-basis">

        <div
          class="icons-accordion-element__title col-grow"
          v-html="$u.localize(value.title)"/>

      </div>

      <div
        v-if="hasBody">

        <q-btn
          round
          unelevated
          v-if="expanded"
          icon="fa lni-chevron-up"
          @click="expanded = false"/>

        <q-btn
          round
          v-else
          unelevated
          @click="expanded = true"
          icon="fa lni-chevron-down"/>

      </div>

    </div>

    <transition-expand>

      <div
        v-if="hasBody && expanded">

        <div
          v-html="$u.localize(value.body)"
          class="icons-accordion-element__body fr-view"/>

      </div>

    </transition-expand>

  </page-block>

</template>

<script>

  import PageBlock from '@src/components/page/page-block';
  import PageElementMixin from '@src/mixins/page-element-mixin';
  import TransitionExpand from '@src/components/transition/transition-expand';

  export default {
    name: 'icons-accordion-element',
    mixins: [
      PageElementMixin,
    ],
    props: {
      value: {
        type: Object,
        required: true,
      },
    },
    components: {
      PageBlock,
      TransitionExpand,
    },
    data() {
      return {
        expanded: false,
      };
    },
  };

</script>

<style lang="scss">

  $gap: 24px;
  $cls: icons-accordion-element;

  .icons-accordion-element {
    overflow: hidden;
    border-radius: $card-radius;

    .#{$cls}__body {
      min-height: 0;
      padding-top: $gap;
    }

    &.has-image {

      @media (min-width: $breakpoint-xs) {
        .#{$cls}__body {
          margin-left: $gap + 80px;
        }
      }
    }

    &__title {
      font-weight: 500;
      font-size: 1.15rem;
    }

    &__header {
      display: flex;
      margin-top: -$gap;
      margin-left: -$gap;
      align-items: center;

      @media (max-width: $breakpoint-xs) {
        flex-direction: column;
      }
    }

    &__header > div {
      padding-top: $gap;
      padding-left: $gap;
    }
  }

</style>
